import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { JwtHelperService } from "@auth0/angular-jwt";
import { RoleTypeEnum } from "src/app/enum/roles.enum";
import { SweetAlertService } from "src/app/services/shared-service/sweetalert/sweet-alert.service";
@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private jwtHelper: JwtHelperService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = localStorage.getItem("token");
    const expectedUserType = next.data.expectedRole;
    try {
      const decodedToken=this.jwtHelper.decodeToken(token)
      const userType =
      decodedToken.type == "0"
        ? RoleTypeEnum.ORGANIZATION_ROLE
        : RoleTypeEnum.CLIENT_ROLE;
      const isTokenExpired=this.jwtHelper.isTokenExpired(token)
      if (isTokenExpired) {
        throw new Error("User is not authenticated");
      }
      if (expectedUserType) {
        if (expectedUserType.some((x) => x == userType)) return true;
        else {
          if (state.url.includes("client/dashboard")) {
            if (userType == RoleTypeEnum.CLIENT_ROLE)
              this.router.navigate(["client/dashboard"]);
            else {
              this.router.navigate(["admin/dashboard"]);
            }
            return false;
          }
          this.router.navigate(["page-not-found"]);
          return false;
        }
      }
      return true;
    } catch (err) {
      localStorage.clear();
      this.router.navigate(["/authentication/signin"]);
      return true;
    }
  }
}
